<template>
  <div class="contractors-main-table__row contractors-main-table__header">
    <div class="contractors-main-table__cell contractors-main-table__cell_index" />
    <div class="contractors-main-table__cell contractors-main-table__cell_name">
      {{ $t('Name') }}
    </div>
    <div class="contractors-main-table__cell">{{ $t('Contacts') }}</div>
    <div class="contractors-main-table__cell">{{ $t('Works') }}</div>
    <div class="contractors-main-table__cell">{{ $t('Tenders') }}</div>
    <div class="contractors-main-table__cell" />
  </div>
</template>

<script>
  export default {
    name: 'ContractorsMainTableHeader',
  };
</script>
